import { Box, Card, CardContent, Typography } from '@mui/material'

import ChangeLogItem from '@/components/ChangeLogItem'
import type { SubjectChangeActivity } from '@/lib/apollo/query/getSubjectChangeActivities/dataTransformations'
import { formatAuthorLabel } from '@/utils/author'

export interface Props {
  activities: SubjectChangeActivity[]
}

export const ChangeLogFeed = ({ activities }: Props) => {
  if (!activities || activities.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ p: 2 }}>
        No activities to display.
      </Typography>
    )
  }

  return (
    <Box>
      {activities.map(activity => (
        <Card key={activity.id} variant="outlined" sx={{ mb: 2 }}>
          <CardContent sx={{ p: 0 }}>
            <Box
              sx={{
                p: 2,
                bgcolor: 'action.hover',
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Box>
                <Typography variant="h6" component="h3" color="default">
                  {activity.source.metadata.section} Section
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Activity ID: {activity.id}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block">
                Event Type: {activity.source.metadata.activityType} | Event:{' '}
                {activity.source.eventName}
              </Typography>
              {activity.author && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mt: 0.5 }}
                >
                  Author: {formatAuthorLabel(activity.author)}
                </Typography>
              )}
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
                sx={{ mt: 0.5 }}
              >
                Date: {new Date(activity.createdAt).toLocaleString()}
              </Typography>
            </Box>

            <Box>
              {activity.changes.length > 0 ? (
                activity.changes.map((change, index) => (
                  <ChangeLogItem
                    key={`${change.path}-${change.fieldName}-${index}`}
                    {...change}
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                  No specific field changes recorded for this activity.
                </Typography>
              )}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  )
}

export default ChangeLogFeed
